module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hMI8pf/tc-custom/9781504093651.jpg?1728259219420",
      "alt": "This image is the cover for the book Murder on Tour, Francis Meadowes"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Murder on Tour, Francis Meadowes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A novice detective joins a rock star’s entourage to follow a trail of sex, drugs, and suspicious deaths, in this brand-new murder mystery by the author of "), _c('i', [_vm._v("Murder Your Darlings")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v(" Crime writer Francis Meadowes has just been offered his first paid detective gig—which means going on the road with gender-fluid rock star JonniK, tagging along as the musician’s entourage travels from Berlin to Brussels and beyond. Jonni’s manager is already worried by a guitar tech’s fatal overdose on a tour bus, but then the star himself is attacked on stage . . ."), _c('br'), _c('br'), _vm._v(" Another shock comes as Jonni’s lead guitarist is electrocuted by his own instrument in the middle of a gig—and Francis realises he is in a dangerous race against time to find out exactly what is going on . . ."), _c('br'), _c('br'), _c('b', [_vm._v("Praise for the Francis Meadowes mysteries")]), _c('br'), _c('br'), _vm._v(" “A rollicking read.” —"), _c('i', [_vm._v("London Evening Standard")]), _c('br'), _c('br'), _vm._v(" “Very engaging.” —"), _c('i', [_vm._v("The Sydney Morning Herald")]), _c('br'), _c('br'), _vm._v(" “Readers will have fun.” —"), _c('i', [_vm._v("Publishers Weekly")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mark McCrum\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0